import React from 'react'
import { PlainField } from './PlainField';

const TimeField = ({ ...props }) => {
	props.type = 'time';
	props.fieldType = 'time';
	return (<PlainField {...props} />)
}

export default TimeField